// src/Components/BankingReconciliation/components/StatusTabs.jsx
import React from "react";
import Styles from "./StatusTabs.module.css";
import { STATUS_META, STATUS_ORDER } from "../../utils/reconFormat";

const StatusTabs = ({ active, counts, total, shownCount, onChange }) => {
  const tabs = [
    { key: "ALL", label: "All", count: total },
    ...STATUS_ORDER.map((key) => ({ key, label: STATUS_META[key].label, count: counts[key] || 0 })),
  ];

  return (
    <div className={Styles.wrap}>
      <div className={Styles.tabs}>
        {tabs.map((t) => (
          <button
            key={t.key}
            type="button"
            className={`${Styles.tab} ${active === t.key ? Styles.active : ""}`}
            onClick={() => onChange(t.key)}
          >
            {t.label}
            <span className={Styles.badge}>{t.count}</span>
          </button>
        ))}
      </div>
      <span className={Styles.count}>
        {shownCount} of {total} requisitions
      </span>
    </div>
  );
};

export default StatusTabs;
